import { jsx as e, jsxs as L } from "react/jsx-runtime";
import { useRef as M } from "react";
import { TooltipArrowVars as l, TooltipContainer as O, TooltipContent as R, TooltipArrow as y } from "./style.js";
import { FloatingElementWrapper as z } from "../FloatingElementWrapper/index.js";
import { useGetFloatingElementPosition as B } from "../../hooks/useGetFloatingElement/index.js";
import { FloatingElementVerticalPosition as p } from "../FloatingElementWrapper/consts.js";
function D({
  children: f,
  content: d,
  className: T,
  openTo: o,
  childrenRef: w,
  isVisible: h,
  hasHeader: E
}) {
  const s = M(null), t = 16, a = t / 2, i = 24, P = 8 + a, { childrenPositions: g, floatingElementSizes: u } = B({
    childrenRef: w,
    FloatingElementRef: s,
    elementMargin: P,
    hasHeader: E
  }), r = u.width, n = g.width / 2, c = r - t - n, m = r - i - t, x = {
    LEFT: c >= m ? m : c,
    MIDDLE: r / 2 - a,
    RIGHT: n <= i ? i : n
  }, F = {
    [l.TOP]: o.vertical === p.BOTTOM ? "-6px" : "none",
    [l.BOTTOM]: o.vertical === p.TOP ? "-6px" : "none",
    [l.LEFT]: `${x[o.horizontal]}px`
  };
  return /* @__PURE__ */ e(
    z,
    {
      className: T,
      openTo: o,
      isVisible: h,
      floatingElement: /* @__PURE__ */ e(O, { children: /* @__PURE__ */ L(R, { ref: s, children: [
        d,
        /* @__PURE__ */ e(y, { style: F })
      ] }) }),
      children: f
    }
  );
}
export {
  D as Tooltip
};
